// The progress badge in the header, as data: belt, streak, today's dots and total XP.

import type { Progress } from "./progressRules.ts";
import { t } from "../i18n/common.ts";

export interface HudView {
    beltName: string;
    beltColor: string;
    beltPct: number;
    xp: string;
    todayDots: string;
    todayTitle: string;
    todayDone: boolean;
    streak: string;
    streakActive: boolean;
}

export function hudView(summary: Progress): HudView {
    const { practices, goal } = summary.today;
    const streak = summary.streak.current;
    return {
        beltName: t("belt", summary.belt.name),
        beltColor: summary.belt.color,
        beltPct: Math.min(100, summary.belt.progressPct),
        xp: `${summary.totalXp} XP`,
        // One dot per practice done today, hollow for the ones still to go.
        todayDots: "●".repeat(Math.min(practices, goal)) + "○".repeat(Math.max(0, goal - practices)),
        todayTitle: t("practicesToday", practices, goal),
        todayDone: practices >= goal,
        streak: streak > 0 ? t("streakDays", streak) : "",
        streakActive: summary.streak.activeToday,
    };
}
